<script lang="ts">
  import videoStore from '../../../stores/video.svelte'
  import componentAttributesStore from '../../../stores/componentAttributes.svelte'
  import chaptersStore from '../../../stores/chapters.svelte'
  import Poster from '../../Poster.svelte'
  import VodSummaryScreen from './VodSummaryScreen.svelte'
  import VodChaptersScreen from './VodChaptersScreen.svelte'
  import Overlay from '../Overlay.svelte'
  import VodBottomPanel from './VodBottomPanel.svelte'
</script>

{#if !videoStore.state.hasPlaybackStarted && videoStore.state.videoWidth && !componentAttributesStore.state.autoplay}
  <Poster />
{/if}
{#if videoStore.state.currentSummary}
  <VodSummaryScreen />
{:else if chaptersStore.state.chaptersScreenOpen}
  <VodChaptersScreen />
{:else}
  <Overlay>
    <VodBottomPanel />
  </Overlay>
{/if}
